import { useMemo } from 'react';
import { mergeDimensions } from '../adapters/mergeDimensions';
import { prepareChartDimensions } from '../adapters/chartDimensionAdapter';
import { prepareMeasureFieldOptions } from '../utils/measureFieldUtils';
import useAnalyticsFormFields from './useAnalyticsFormFields';

export default function useReportDimensions(
  catalogDimensions,
  { dataset, campaignIds, leadsFormIds, chartType }
) {
  const { formFields, isLoading: isLoadingFormFields } = useAnalyticsFormFields(
    dataset,
    campaignIds,
    leadsFormIds
  );

  const dimensions = useMemo(
    () => mergeDimensions(catalogDimensions, formFields),
    [catalogDimensions, formFields]
  );

  const chartDimensions = useMemo(
    () => prepareChartDimensions({
      dimensions,
      chartType,
      leadsFormIds,
      campaignIds,
      dataset,
    }),
    [dimensions, chartType, leadsFormIds, campaignIds, dataset]
  );

  const measureFieldOptions = useMemo(
    () => prepareMeasureFieldOptions(formFields),
    [formFields]
  );

  return {
    dimensions,
    groupByOptions: chartDimensions.groupByOptions,
    measureFieldOptions,
    timeFieldOptions: chartDimensions.timeFieldOptions,
    needsTableColumns: chartDimensions.needsTableColumns,
    formFields,
    isLoadingFormFields,
  };
}
